export default __webpack_public_path__ + "static/media/bg-2.1e803895.svg";